import { Box, StepLabel, useMediaQuery } from "@mui/material";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { ServiceStatusRdn } from '@chr/online-shared-ui-constants';

import { BookingStatusIcon, Step, Stepper } from "@/common/components/stepper";
import customTheme from "@/common/components/theme-provider/customTheme";

const getActiveStep = (statusId: number) => {
  switch (statusId) {
    case ServiceStatusRdn.INCOMPLETE:
    case ServiceStatusRdn.READY_TO_PLAN:
    case ServiceStatusRdn.PARTIALLY_PLANNED:
    case ServiceStatusRdn.PLANNED:
      return 0;
    case ServiceStatusRdn.BOOKED:
    case ServiceStatusRdn.PARTIALLY_BOOKED:
      return 1;
    case ServiceStatusRdn.IN_TRANSIT:
      return 2;
    case ServiceStatusRdn.DELIVERED:
      return 3;
    default:
      return 0;
  }
};

export interface BookingStatusProps {
  statusId: number;
}

export const BookingStatus = ({ statusId }: BookingStatusProps) => {
  const translate = useTranslation();
  const theme = customTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const activeStep = getActiveStep(statusId);

  const orientation = isMobileScreen ? 'vertical' : 'horizontal';
  const mainStyles = isMobileScreen ?
    { display: 'flex', justifyContent: 'center' } :
    { padding: '12px 14px 20px 14px', };

  return (
    <Box sx={mainStyles}>
      <Stepper
        alternativeLabel={isMobileScreen}
        orientation={orientation}
        activeStep={activeStep}
        aria-label={translate('Booking Status')}
        data-testid={`booking-status-active-${activeStep}`}
      >
        <Step key="Ordered" stepIds="bookingStatus">
          <StepLabel StepIconComponent={BookingStatusIcon}>{translate('Ordered')}</StepLabel>
        </Step>

        <Step key="Booked" stepIds="bookingStatus">
          <StepLabel StepIconComponent={BookingStatusIcon}>{translate('Booked')}</StepLabel>
        </Step>

        <Step key="InTransit" stepIds="bookingStatus">
          <StepLabel StepIconComponent={BookingStatusIcon}>{translate('In Transit')}</StepLabel>
        </Step>

        <Step key="Delivered" stepIds="bookingStatus">
          <StepLabel StepIconComponent={BookingStatusIcon}>{translate('Delivered')}</StepLabel>
        </Step>
      </Stepper>
    </Box>
  );
};
